<template>
	<b-modal
		v-model="showPayment"
		id="paymentmodal"
		size="md"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		@hidden="$emit('close-modal')"
	>
		<b-overlay :show="paymentProcessing" rounded="sm">
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-body-3">
						<div class="payment-header position-relative">
							<div
								class="payment-header-txt d-flex align-items-center ml-3 h-100"
							>
								Choose the perfect <br />plan for you
							</div>
							<div class="payment-header-img">
								<img
									src="../../../assets/icons/payments/headerimage.png"
									alt=""
								/>
							</div>
							<div
								class="payment-cross-img rotate-on-hover pointer"
								@click="
									(quantity = 1),
										(uparrow = false),
										(downarrow = false),
										$emit('close-modal')
								"
							>
								<img src="../../../assets/icons/payments/x-close.svg" alt="" />
							</div>
						</div>

						<div
							class="d-flex flex-column justify-content-center align-items-center"
						>
							<div
								class="w-80 mt-5 d-flex justify-content-start p-most-recom-txt"
							>
								Most Recommended
							</div>

							<div
								class="w-80 d-flex flex-column align-items-center justify-content-center"
							>
								<!-- for selected bind the class "payment-infoselected-container" -->
								<!-- <div
                  class="payment-infoselected-container position-relative d-flex align-items-center w-100"
                >
                  <div class="payment-info-container-selected-box">
                    Selected
                  </div>
                  <div class="pl-3" style="width: 60%">
                    <div class="position-relative">
                      <span class="payment-cost-price-symbol">₹</span>
                      <span class="payment-cost-price">{{
                        creditData.templateCost * quantity
                      }}</span>
                    </div>
                  </div>
                  <div style="width: 30%" class="d-flex align-items-center">
                    <div class="payment-no-of-resumes">5</div>
                    <div class="fw-400 p-most-recom-txt ml-1">Resumes</div>
                  </div>
                  <div style="width: 10%" class="pb-1 position-relative">
                    <img src="../../../assets/img/pinfo.svg" class="pointer" @mouseover="referHover = !referHover" alt="" />
                    <div class="refer-info" v-if="referHover">
                <div
                  class="d-flex align-items-center asp-small-txt text-center"
                >
                This includes both graphical and ATS <br> resume downloads
                </div>
              </div>
                  </div>
                </div> -->

								<div
									@click="selectedPromo = promo"
									:class="{
										'payment-infoselected-container':
											selectedPromo.itemID == promo.itemID,
										'mt-3': index != 0,
									}"
									v-for="(promo, index) in promoData"
									:key="promo.itemID"
									class="payment-info-container position-relative d-flex align-items-center w-100 pointer"
								>
									<div
										v-if="selectedPromo.itemID == promo.itemID"
										class="payment-info-container-selected-box"
									>
										Selected
									</div>
									<div class="pl-3" style="width: 45%">
										<div class="position-relative">
											<span class="payment-cost-price-symbol">₹</span>
											<span class="payment-cost-price">{{ promo.amount }}</span>
										</div>
									</div>
									<div
										style="width: 45%"
										class="d-flex align-items-center justify-content-end"
									>
										<div class="payment-no-of-resumes">
											{{ promo.downloads }}
										</div>
										<div class="fw-400 p-most-recom-txt ml-1">Resumes</div>
									</div>
									<div style="width: 10%" class="pb-1 position-relative ml-3">
										<img
											src="../../../assets/img/pinfo.svg"
											class="pointer"
											@mouseover="(referHover = true), showHover(index, true)"
											@mouseout="
												(referHover = !referHover), showHover(index, false)
											"
											alt=""
										/>
										<div
											class="refer-info"
											v-if="referHover && promo.showHover"
										>
											<div
												class="d-flex align-items-center asp-small-txt text-center"
											>
												This includes both graphical and ATS
												<br />
												resume downloads
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="mt-2">
                <span class="per-resume-cost"
                  >₹{{ creditData.templateCost }}</span
                ><span class="payment-tot-cost-txt">/per resume</span>
              </div>
              <div class="mt-3 position-relative">
                <span class="payment-cost-price-symbol">₹</span>
                <span class="payment-cost-price">{{
                  creditData.templateCost * quantity
                }}</span>
                <span class="payment-tot-cost-txt ml-2">Total cost</span>
              </div>
              <div class="mt-3 d-flex align-items-center">
                <div class="payment-resume-count-box d-flex align-items-center">
                  <div class="payment-resume-count-number">{{ quantity }}</div>
                  <div class="payment-resume-count-txt ml-1">Resume</div>
                </div>
                <div class="ml-3 d-flex flex-column updownbutton">
                  <div
                    class="top-bottom h-50 w-100 d-flex align-items-center justify-content-center pointer"
                    @click="quantity++, (downarrow = false), (uparrow = true)"
                  >
                    <img
                      v-if="!uparrow"
                      src="../../../assets/icons/payments/uparrow (2).svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../../assets/icons/payments/activetoparrow.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="bottom-top h-50 w-100 d-flex align-items-center justify-content-center pointer"
                    @click="
                      quantity == 1
                        ? null
                        : (quantity--, (downarrow = true), (uparrow = false))
                    "
                  >
                    <img
                      v-if="!downarrow"
                      src="../../../assets/icons/payments/downarrow.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../../assets/icons/payments/activedownarrow.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div> -->
							<div class="mt-4 payment-description-txt">
								Pre-pay, pick your quantity, download seamlessly
								<br id="hideinmobile" />
								when needed
							</div>
							<div class="mt-1 mb-2 payment-line"></div>
							<div class="mt-1">
								<div class="payment-points">
									<img src="../../../assets/icons/payments/Tick.svg" alt="" />
									Professional resume templates
								</div>
								<div class="payment-points">
									<img
										src="../../../assets/icons/payments/Tick.svg"
										class="mr-1"
										alt=""
									/>Unlock Video snapshot feature
								</div>
								<div class="payment-points">
									<img
										src="../../../assets/icons/payments/Tick.svg"
										class="mr-1"
										alt=""
									/>Resumes without watermark
								</div>
								<div class="payment-points">
									<img src="../../../assets/icons/payments/Tick.svg" alt="" />
									One Pager graphical resume
								</div>
							</div>
						</div>
					</div>
					<div
						class="p-3 w-100 d-flex flex-column align-items-center justify-content-center mt-3"
					>
						<b-button
							class="w-50 candash-addBtn pointer"
							@click="makeDownloadPayment()"
							>Pay Now</b-button
						>
						<div
							class="payment-bcktxt mt-3 pointer"
							@click="
								(quantity = 1),
									(uparrow = false),
									(downarrow = false),
									$emit('close-modal')
							"
						>
							<img src="../../../assets/img/bck.svg" alt="" />
							Back
						</div>
						<div style="display: none" ref="responseContainer"></div>
					</div>
				</div>
			</div>
		</b-overlay>
	</b-modal>
</template>

<script>
import {
	createNewOrder,
	triggerClick,
} from "../../../controllers/dashboard/asynchronous";
import errorModal from "../../../components/mixin/toast";
import successModal from "../../../components/mixin/toast";
import { mapGetters } from "vuex";

export default {
	name: "PaymentModal",
	props: {
		showPayment: Boolean,
		creditData: Object,
		userEmail: String,
		customerID: String
	},
	mixins: [errorModal, successModal],
	data() {
		return {
			paymentProcessing: false,
			paymentButton: "",
			quantity: 1,
			downarrow: false,
			uparrow: false,
			referHover: false,
			selectedPromo: {},
		};
	},
	watch: {
		paymentButton(value) {
			if (value) {
				triggerClick(this);
			}
		},
	},
	created() {
		this.promoData.map((obj) => {
			return (obj.showHover = false);
		});
		console.log(this.promoData);
		this.selectedPromo = this.promoData[0];
		this.getPaymentFailure();
	},
	computed: {
		...mapGetters("userVUEX", {
			promoData: "getPromoData",
		}),
	},
	mounted() {
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		window.addEventListener("message", this.handleMessage);
	},
	beforeDestroy() {
		// Remove the event listener when the component is destroyed
		window.removeEventListener("message", this.handleMessage);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
	},
	methods: {
		showHover(i, type) {
			this.promoData.map((obj) => {
				return (obj.showHover = false);
			});
			this.promoData[i].showHover = type;
		},
		handleBeforeUnload(event) {
			if (this.paymentProcessing) {
				event.preventDefault(); // This is necessary to display the alert message
			}
		},
		getPaymentFailure() {
			const originalLog = console.log;
			console.log = (...args) => {
				// Call the original console.log method
				originalLog.apply(console, args);
				// Check if the logged message contains the data you're interested in
				const logMessage = args.join(" ");
				if (
					logMessage.includes("payment cancelled") &&
					this.paymentProcessing
				) {
					this.errorModal("Error", "Payment cancelled!");
					this.paymentProcessing = false;
				}
			};
		},
		handleMessage(event) {
			if (event.data.data) {
				if (event.data.data.type == "Success") {
					this.paymentProcessing = false;
				}
				this.$emit("downloadDone", event.data.data);
			}
		},
		async makeDownloadPayment() {
			this.paymentProcessing = true;
			let arr = [{ itemID: this.selectedPromo.itemID, quantity: this.selectedPromo.downloads }];
			let payload1 = {
				customerID: this.customerID,
				items: arr,
				currency: "INR",
				platform: "REC_CANDIDATE",
			};
			createNewOrder(this, payload1);
		},
	},
};
</script>

<style>
.updownbutton {
	background: #eef3f7;
	height: 35px;
	width: 35px;
	height: 35px;
	width: 35px;
	justify-content: space-around;
	border-radius: 50px;
}
.top-bottom:hover {
	background: #c8d9e5;
	border-top-left-radius: 50px;
	border-top-right-radius: 50px;
}
.bottom-top:hover {
	background: #c8d9e5;
	border-bottom-left-radius: 50px;
	border-bottom-right-radius: 50px;
}
</style>
